import { render, staticRenderFns } from "./tween-input-number.vue?vue&type=template&id=38148c01&scoped=true&"
import script from "./tween-input-number.vue?vue&type=script&lang=js&"
export * from "./tween-input-number.vue?vue&type=script&lang=js&"
import style0 from "./tween-input-number.vue?vue&type=style&index=0&id=38148c01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38148c01",
  null
  
)

export default component.exports